document.addEventListener('DOMContentLoaded',function(){
  var cancel = document.querySelector(".cancel");
  var img1 = document.querySelector(".img1");
  var img2 = document.querySelector(".img2");
  var astmHigh = document.querySelector("#astm-high");
  var highBtn = document.getElementById("highBtn");

  highBtn.addEventListener("click",function(){

    astmHigh.style.display = "block";
  });
    cancel.addEventListener("click",function(e){
    astmHigh.style.display = "none";
  })  
 })

